import type { Notice } from "../services/api/types";
import { isUpcomingScheduledNotice } from "./noticeScheduling";

/** Mirrors backend feed-hidden rules for the dashboard published list. */
export function isNoticeHiddenFromPublishedList(
  notice: Pick<
    Notice,
    "publishStatus" | "publishAt" | "excludeFromFeed" | "isDraft"
  >
): boolean {
  if (isUpcomingScheduledNotice(notice)) {
    return true;
  }
  return notice.excludeFromFeed === true;
}
